/**
 * SubTenantEnv — tracks which environment (draft or live) the current
 * sub-tenant page belongs to. Derived from the URL path, mirroring
 * the Library's LibraryEnvContext pattern:
 *
 *   /.../sub-tenants/:sid/draft   → env = "draft"  (editable)
 *   /.../sub-tenants/:sid/live    → env = "live"   (read-only)
 *   anything else                 → env = "draft"  (safe default)
 *
 * Because env is in the URL, no React state is needed — the hook just
 * reads the current location. This makes bookmarks, tab highlights,
 * and back/forward navigation work naturally.
 */

import { useLocation } from "react-router-dom";

/**
 * Returns { env, isDraft, isLive } based on the current path.
 */
export function useSubTenantEnv() {
  const loc = useLocation();
  const isLive = /\/sub-tenants\/[^/]+\/live/.test(loc.pathname);
  return {
    env: isLive ? "live" : "draft",
    isDraft: !isLive,
    isLive,
  };
}
